(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-plush-motif-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gm-plush-motif-story')) {
    customElements.define('gm-plush-motif-story', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-story-variants]').textContent);
        this.onVariantChange = (event) => {
          const variant = this.variants.find(item => item.id === event.detail?.variant?.id);
          const image = this.querySelector('.gm-plush-motif-story__image img');
          if (!variant?.featured_image?.src || !image) return;
          const url = new URL(variant.featured_image.src, location.origin);
          url.searchParams.set('width', '1000');
          image.removeAttribute('srcset');
          image.src = url.href;
        };
        document.addEventListener('product:variant-change', this.onVariantChange);
      }
      disconnectedCallback() {
        document.removeEventListener('product:variant-change', this.onVariantChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
